<template>
    <button
        class="tiptap-btn"
        type="button"
        :title="$t('Strikethrough')"
        :disabled="disabled || !editor.can().chain().focus().toggleStrike().run()"
        :class="{ 'is-active': editor.isActive('strike') }"
        @click="editor.chain().focus().toggleStrike().run()">
        <FormatStrikethroughIcon size="16"/>
    </button>
</template>

<script>
import FormatStrikethroughIcon from '@/common/components/svg-icons/FormatStrikethroughIcon.vue';
import {Editor} from '@tiptap/vue-2';

export default {
    name: 'MenuBarStrikeButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        FormatStrikethroughIcon
    }
};
</script>
